/*@ngInject*/
const SessionTimeoutModalController = function ($rootScope, $scope, message, title, $timeout, coreConstant) {

    let timeoutList = [];

    $scope.message = message;
    $scope.title = title;

    $scope.$on(coreConstant.event.UPDATE_SESSION_COUNTDOWN_MESSAGE, function (event, message) {
        // Force digest since this event is being triggered by a non angular lib
        timeoutList.push($timeout(function () {
            $scope.message = message;
        }, 0));
    });

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('umCore')
    .controller('sessionTimeoutModalController', SessionTimeoutModalController);
